import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#f8f8f8",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#59ad3b",
      d: "M31 20.4c-1.84 0-3.545-.513-4.937-1.385v6.29c0 3.14-2.93 5.695-6.531 5.695a7.165 7.165 0 0 1-3.744-1.032C14.104 28.937 13 27.231 13 25.304c0-3.14 2.93-5.696 6.532-5.696.3 0 .592.021.88.055V22.822a3.349 3.349 0 0 0-.88-.12c-1.644 0-2.982 1.167-2.982 2.602 0 1 .65 1.867 1.6 2.303.413.19.884.298 1.383.298 1.607 0 2.918-1.114 2.978-2.503L22.514 13h3.548c0 .268.03.53.084.785.25 1.18 1.052 2.191 2.165 2.823.774.44 1.697.698 2.688.698L31 20.4Z"
    }, null, -1)
  ])))
}
export default { render: render }